import { NgModule } from '@angular/core';
import { NbCardModule, NbIconModule, NbInputModule, NbToggleModule, NbActionsModule, NbSpinnerModule } from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';

import { ThemeModule } from '../../@theme/theme.module';
import { routedComponents, MenusRoutingModule} from './menus-routing.module';
import { FormsModule } from '@angular/forms';
import { NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { EditMenuComponent } from './edit-menu/edit-menu.component';
import { ListeMenuComponent } from './liste-menu/liste-menu.component';
import { NgxTreeDndModule } from 'ngx-tree-dnd';
import { NewMenuComponent } from './new-menu/new-menu.component';
import { UpdateMenuComponent } from './update-menu/update-menu.component';
import { MenuComponent } from './menu.component';


@NgModule({
  imports: [
    NbCardModule,
    NbIconModule,
    NbInputModule,
    ThemeModule,
    MenusRoutingModule,
    Ng2SmartTableModule,
    FormsModule,
    NbToggleModule,
    NgbModule,
    NgMultiSelectDropDownModule, 
    NbActionsModule,
    NbSpinnerModule,
    NgxTreeDndModule, 
  ],
  entryComponents: [
    EditMenuComponent,
    ListeMenuComponent,
    MenuComponent,
    NewMenuComponent,
    UpdateMenuComponent
  ],
  declarations: [
    EditMenuComponent,
    ListeMenuComponent,
    MenuComponent,
    NewMenuComponent,
    UpdateMenuComponent,
    ...routedComponents,
  ],
})
export class MenusModule { }
